import { render, staticRenderFns } from "./DownloadMobile.vue?vue&type=template&id=3aebbafe&scoped=true&"
import script from "./DownloadMobile.vue?vue&type=script&lang=js&"
export * from "./DownloadMobile.vue?vue&type=script&lang=js&"
import style0 from "./DownloadMobile.vue?vue&type=style&index=0&id=3aebbafe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aebbafe",
  null
  
)

export default component.exports